import { Fieldset } from './primitive/Fieldset';
import { Field } from './primitive/Field';
import { Radio } from './primitive/Radio';
import * as stylex from '@stylexjs/stylex';
import { FieldBuilderComponentPropsType } from '../types';
import { tinaField } from 'tinacms/react';
type RadioInputProps = FieldBuilderComponentPropsType<'ConversionFormStepsFieldsRadioList'>;
export function RadioInput({
  data,
  name
}: RadioInputProps) {
  return <Field.Root name={name}>
      <Fieldset.Root render={<Radio.RadioGroup columns={data.layout === 'vertical' ? 1 : 3} />}>
        <Fieldset.Legend styles={sx.radioLegend} data-tina-field={tinaField(data, 'label')}>
          {data.label}
        </Fieldset.Legend>
        {data.values?.map(value => {
        if (!value) return null;
        return <Field.Item key={value.value}>
              <Field.Label>
                <Radio.Root value={value.value}>
                  <Radio.Indicator />
                </Radio.Root>
                {value.value}
              </Field.Label>
            </Field.Item>;
      })}
      </Fieldset.Root>
      <Field.Error />
      <Field.Description>{data.hint}</Field.Description>
    </Field.Root>;
}
type RadioImageInputProps = FieldBuilderComponentPropsType<'ConversionFormStepsFieldsRadioImageList'>;
export function RadioImageInput({
  data,
  name
}: RadioImageInputProps) {
  return <Field.Root name={name}>
      <Fieldset.Root render={<Radio.RadioGroup columns={2} />}>
        <Fieldset.Legend data-tina-field={tinaField(data, 'label')} styles={sx.radioLegend}>
          {data.label}
        </Fieldset.Legend>
        {data.values?.map(value => {
        if (!value) return null;
        return <Field.Item key={value.value}>
              <Field.Label>
                <Radio.Root value={value.value}>
                  <Radio.Indicator />
                </Radio.Root>
                {value.image && <Field.Icon src={value.image} />}
                {value.value}
              </Field.Label>
            </Field.Item>;
      })}
      </Fieldset.Root>
      <Field.Error />
      <Field.Description>{data.hint}</Field.Description>
    </Field.Root>;
}
const sx = {
  radioLegend: {
    kWZpDQ: "xx1abn8",
    kEXP64: "xcrlgei",
    $$css: true
  }
};